import { normalizeWorkOrderStatusKey, WORK_ORDER_STATUS } from 'settings/constants/service'

import type { RevisionLike } from 'utils/activity/ActivityTreeBuilder'

const LABEL_BY_STATUS: Record<string, string> = {
  [normalizeWorkOrderStatusKey(WORK_ORDER_STATUS.SERVICED)]: 'Serviced At',
  [normalizeWorkOrderStatusKey(WORK_ORDER_STATUS.SKIPPED)]: 'Skipped At',
}

/** serviced_at stamps both Serviced and Skipped, and is cleared under a non-terminal status — hence previous. */
export const completionStampLabel = (current: RevisionLike, previous: RevisionLike | null): string =>
  LABEL_BY_STATUS[normalizeWorkOrderStatusKey(current.workOrderStatus)] ||
  LABEL_BY_STATUS[normalizeWorkOrderStatusKey(previous?.workOrderStatus)] ||
  'Serviced At'
